import { toSafeString } from '@shared/utils';

// Builds { metadataById, metadataBySlug } lookups (each value { icon, name, publishedVersion }) from the app metadata
// collection plus a workflow's own appMetadataById, for enriching workflow steps with their app icon, name and published
// version. Only the collection knows the published version, so a workflow's own entry for the same app keeps it.
const buildAppMetadataMaps = ({ appsMetadataItems, appMetadataById } = {}) => {
  const metadataById = {};
  const metadataBySlug = {};
  const items = Array.isArray(appsMetadataItems) ? appsMetadataItems : [];
  const byIdValues = appMetadataById && typeof appMetadataById === 'object' && !Array.isArray(appMetadataById) ? Object.values(appMetadataById) : [];

  for (const app of [...items, ...byIdValues]) {
    if (!app?.icon && !app?.name) {
      continue;
    }

    const id = toSafeString(app?.id);
    const slug = toSafeString(app?.slug).toLowerCase();
    const meta = { icon: app.icon || null, name: app.name || null, publishedVersion: app.publishedVersion || metadataById[id]?.publishedVersion || null };

    if (id) {
      metadataById[id] = meta;
    }

    if (slug) {
      metadataBySlug[slug] = meta;
    }
  }

  return { metadataById, metadataBySlug };
};

export default buildAppMetadataMaps;
